import script from "./ecologyTargetSignedList.vue?vue&type=script&setup=true&lang=js"
export * from "./ecologyTargetSignedList.vue?vue&type=script&setup=true&lang=js"

import "./ecologyTargetSignedList.vue?vue&type=style&index=0&id=dcb99fd2&lang=scss"

const __exports__ = script;

export default __exports__